(() => {
  let data = {};
  try {
    data = JSON.parse(document.getElementById('AhfCardMetaData')?.textContent || '{}');
  } catch (e) {
    return;
  }

  const build = (item) => {
    const meta = document.createElement('div');
    meta.className = 'ahf-card-meta';

    if (item.b) {
      const benefit = document.createElement('p');
      benefit.className = 'ahf-card-meta__benefit';
      benefit.textContent = item.b;
      meta.append(benefit);
    }

    if (item.c > 0 && item.r > 0) {
      const rating = document.createElement('p');
      rating.className = 'ahf-card-meta__rating';
      rating.setAttribute('aria-label', `Rated ${item.r.toFixed(1)} out of 5 from ${item.c} reviews`);

      const stars = document.createElement('span');
      stars.className = 'ahf-card-meta__stars';
      stars.setAttribute('aria-hidden', 'true');
      stars.style.setProperty('--ahf-rating', `${(item.r / 5) * 100}%`);

      const text = document.createElement('span');
      text.setAttribute('aria-hidden', 'true');
      text.textContent = `${item.r.toFixed(1)} (${item.c})`;

      rating.append(stars, text);
      meta.append(rating);
    }

    return meta.childElementCount ? meta : null;
  };

  const apply = () => {
    document.querySelectorAll('.card__information a[id^="CardLink-"]').forEach((link) => {
      const heading = link.closest('.card__heading');
      if (!heading || heading.nextElementSibling?.classList.contains('ahf-card-meta')) return;
      const item = data[link.id.split('-').pop()];
      const meta = item && build(item);
      if (meta) heading.after(meta);
    });
  };

  let queued = false;
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      apply();
    });
  };

  apply();
  new MutationObserver(queue).observe(document.body, { childList: true, subtree: true });
})();
